import React from 'react';
import Badge from '../../../../components/common/Badge/Badge';
import Button from '../../../../components/common/Button/Button';
import DataTable from '../../../../components/common/DataTable/DataTable';
import KebabMenu, { KebabMenuItem } from '../../../../components/common/KebabMenu/KebabMenu';
import type { TrainingItem } from '../../../../types/training';
import styles from './TrainingListRow.module.css';

interface TrainingListRowProps {
  training: TrainingItem;
  variant?: 'catalog' | 'student';
  onApply: (training: TrainingItem) => void;
  onOpen: (training: TrainingItem) => void;
  menuItems: KebabMenuItem[];
  showApplyAction?: boolean;
  applyLabel?: string;
  applyDisabled?: boolean;
  applyAlwaysVisible?: boolean;
}

const TrainingListRow: React.FC<TrainingListRowProps> = ({
  training,
  variant = 'catalog',
  onApply,
  onOpen,
  menuItems,
  showApplyAction = true,
  applyLabel = 'Aplicar',
  applyDisabled = false,
  applyAlwaysVisible = false,
}) => (
  <DataTable.Row className={styles['training-row']}>
    <div className={styles['training-cell']}>
      <div className={styles['training-content']}>
        <button
          type="button"
          className={styles['training-name-button']}
          onClick={() => onOpen(training)}
          title={`Abrir treino ${training.name}`}
          aria-label={`Abrir treino ${training.name}`}
        >
          <span className={styles['training-name']} title={training.name}>{training.name}</span>
        </button>
        {training.status && (
          <Badge variant="info" className={styles['status-badge']}>
            {training.status}
          </Badge>
        )}
      </div>
    </div>

    <div className={styles['split-cell']}>
      {training.splits.map((split) => (
        <Badge key={split} variant="primary" className={styles['split-badge']}>
          {split}
        </Badge>
      ))}
    </div>

    <div className={styles['meta-cell']}>
      {variant === 'student' ? (training.deliveredByName ?? '—') : training.loadIntensity}
    </div>

    <div className={styles['meta-cell']}>
      {variant === 'student' ? (training.deliveredAt ?? '—') : training.effortPerception}
    </div>

    <div className={styles['description-cell']} title={`${training.descriptionLabel}: ${training.description}`}>
      <span className={styles['description-label']}>{training.descriptionLabel}:</span>
      <span>{training.description}</span>
    </div>

    <div className={styles['actions-cell']}>
      {showApplyAction && (
        <Button
          variant="primary"
          size="xs"
          className={[
            styles['apply-button'],
            applyAlwaysVisible ? styles['apply-button-always'] : '',
          ].filter(Boolean).join(' ')}
          disabled={applyDisabled}
          onClick={() => onApply(training)}
        >
          {applyLabel}
        </Button>
      )}

      {menuItems.length > 0 && (
        <div className={styles['kebab-wrapper']}>
          <KebabMenu items={menuItems} />
        </div>
      )}
    </div>
  </DataTable.Row>
);

export default TrainingListRow;